if (typeof document === "undefined") return;
var extractCssCreateStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject, fetchPriority
) {
	var linkTag = document.createElement("link");
linkTag.setAttribute("data-vanilla-extract", "true");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;


if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
  linkTag.crossOrigin = 'anonymous';
}


	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	if (oldTag) {
            oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
          } else {
            document.head.appendChild(linkTag);
          }
	return linkTag;
}
var extractCssFindStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var extractCssLoadStylesheet = function (chunkId, fetchPriority) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (extractCssFindStylesheet(href, fullhref)) return resolve();
		extractCssCreateStylesheet(chunkId, fullhref, null, resolve, reject, fetchPriority);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	1427: 0,

};

__webpack_require__.f.miniCss = function (chunkId, promises, fetchPriority) {
	var cssChunks = {
1115: 1,
1178: 1,
1228: 1,
163: 1,
164: 1,
1895: 1,
1896: 1,
1942: 1,
2224: 1,
2756: 1,
2807: 1,
2865: 1,
2866: 1,
2867: 1,
2992: 1,
3024: 1,
3136: 1,
3191: 1,
3316: 1,
3402: 1,
3501: 1,
3582: 1,
3604: 1,
3645: 1,
365: 1,
3662: 1,
3666: 1,
366: 1,
3741: 1,
3820: 1,
3948: 1,
4104: 1,
4174: 1,
4553: 1,
4587: 1,
4654: 1,
4671: 1,
4775: 1,
4873: 1,
4899: 1,
4960: 1,
5014: 1,
5018: 1,
5024: 1,
5184: 1,
5324: 1,
541: 1,
5539: 1,
584: 1,
5902: 1,
5985: 1,
6325: 1,
6386: 1,
6409: 1,
6505: 1,
6629: 1,
6778: 1,
6950: 1,
7051: 1,
70: 1,
7212: 1,
7367: 1,
7386: 1,
7590: 1,
7802: 1,
8143: 1,
8166: 1,
8217: 1,
8255: 1,
8295: 1,
8491: 1,
8517: 1,
8688: 1,
8754: 1,
9165: 1,
916: 1,
9244: 1,
9444: 1,
9488: 1,
9503: 1,
9558: 1,
9572: 1,
9585: 1,
9629: 1,

};
	if (installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if (installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = extractCssLoadStylesheet(chunkId, fetchPriority).then(
				function () {
					installedCssChunks[chunkId] = 0;
				},
				function (e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

// no hmr
// no prefetch
// no preload